import { OidcSecure } from "@axa-fr/react-oidc";
import { Navigate, type RouteObject } from "react-router";
import { GLOBAL_CONFIG } from "@/global-config";
import DashboardLayout from "@/layouts/dashboard";
import { getFrontendDashboardRoutes } from "./frontend";

const getRoutes = (): RouteObject[] => getFrontendDashboardRoutes();

export const dashboardRoutes: RouteObject[] = [
  {
    element: (
      <OidcSecure>
        <DashboardLayout />
      </OidcSecure>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={GLOBAL_CONFIG.defaultRoute} replace />,
      },
      ...getRoutes(),
    ],
  },
];
